import React, { useState } from "react";
import { api } from "@/lib/api";
import { stepOf } from "@/lib/stages";
import { ukDayTime } from "@/lib/time";
import { Btn, Inp } from "./kit";
import { toast } from "sonner";

const REPLIES = [
  ["chased", "I've chased the client"],
  ["call_today", "Client will call you today"],
  ["try_other", "Try a different number or time"],
];

/** While a desk is trying to reach the client, the introducer answers in one tap — it lands on the thread and with that desk. */
export function QuickReply({ leadId, desks, onSent }) {
  const [pick, setPick] = useState(null);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const trying = (desks || []).filter((d) => d.status !== "declined" && stepOf(d) === "no_contact");
  if (!trying.length) return null;
  const last = trying.map((d) => (d.now_reply && d.now_reply.at >= (d.step_at || "") ? d.now_reply : null))
    .filter(Boolean).sort((a, b) => (a.at < b.at ? 1 : -1))[0];
  const names = trying.map((d) => d.alias).join(" and ");

  const send = async () => {
    setBusy(true);
    try {
      await api.post(`/refer/leads/${leadId}/now-reply`, { reply: pick, note: pick === "try_other" ? note.trim() || null : null });
      toast.success("Sent — it's on the case and with the lender now");
      setPick(null);
      setNote("");
      onSent?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "That didn't go through"); }
    finally { setBusy(false); }
  };

  return (
    <div className="qrep" data-testid="quick-reply">
      <div className="qrep-h" data-testid="quick-reply-title">{names} {trying.length === 1 ? "is" : "are"} trying to reach your client</div>
      <div className="qrep-sub" data-testid="quick-reply-sub">
        {last ? <>You replied &ldquo;{last.text}&rdquo; · {ukDayTime(last.at, "—")}. Send another if anything changes.</>
          : "Let the lender know in one tap. It goes on the case thread and straight to them."}
      </div>
      <div className="chips" style={{ marginTop: 14 }}>
        {REPLIES.map(([k, t]) => (
          <button key={k} type="button" className={`chip${pick === k ? " on" : ""}`} onClick={() => setPick(k)}
                  aria-pressed={pick === k} data-testid={`quick-reply-${k}`}>{t}</button>
        ))}
      </div>
      {pick === "try_other" && (
        <Inp value={note} onChange={(e) => setNote(e.target.value)} maxLength={200} style={{ marginTop: 12 }}
             placeholder="e.g. Try 07700 900123, or after 5pm" data-testid="quick-reply-note" />
      )}
      <div style={{ marginTop: 12 }}>
        <Btn kind="primary" onClick={send} disabled={!pick || busy} testId="quick-reply-send">
          {busy ? "Sending…" : "Send to the lender"}
        </Btn>
      </div>
    </div>
  );
}

export default QuickReply;
